$(document).ready(() => {
    InitializeGridBinders($(document) as unknown as JQuery<HTMLElement>);
});

//#region Initalize
function InitializeGridBinders($context: JQuery<HTMLElement>): void {
    GridBinder.instances = [];
    RegisterGridBinders($context);
    RegisterWindowResize();
}

function RegisterGridBinders($context: JQuery<HTMLElement>): void {
    const $gridBinders = $context.findInGrid('.gridBinder');

    RegisterStandardGridBinders($gridBinders);
    RegisterModalSelectGridBinders($gridBinders);

    FilterSubGridBinders();
}
//#endregion Initalize

//#region Helpers
function FilterSubGridBinders(): void {
    // This will only work assuming there can only be 1 sublevel of grids
    $('.gridBinder:has(.gridBinder)').each(function () {
        const gridBinderID = $(this).attr('id');

        if (!gridBinderID) return;

        const gridBinder = findGridBinderById(gridBinderID);

        if (gridBinder) {
            const subGridBinders = gridBinder.$parent.find('.gridBinder');

            subGridBinders.each(function (this: HTMLElement) {
                const subGridID = $(this).attr('id');

                if (!subGridID) return;

                const subGridBinder = findGridBinderById(subGridID);

                if (subGridBinder) {
                    gridBinder.SubGridBinders.push(subGridBinder);
                    removeGridBinderById(subGridID);
                }
            });
        }
    });
}

function findGridBinderById(id: string): GridBinder | undefined {
    return GridBinder.instances.find((gridBinder) => gridBinder.id === id);
}

function removeGridBinderById(id: string): void {
    const index = GridBinder.instances.findIndex(
        (gridBinder) => gridBinder.id === id
    );

    if (index !== -1) {
        GridBinder.instances.splice(index, 1);
    }
}

function RegisterWindowResize(): void {
    // Update the size of collapse panels on window resize.
    $(window).on('resize', () => {
        GridBinder.instances.forEach((instance) => {
            instance.bindWindowReSize();

            instance.subGridBinders.forEach((subInstance) => {
                subInstance.bindWindowReSize();
            });
        });
    });
}
//#endregion Helpers

//#region Register Grid Binders
//include a div with a unique name around form containing search bar, grid, and paging buttons
//then for each of the divs create a GridBinder and set parent and the searchUrl
function RegisterStandardGridBinders($gridBinders: JQuery<HTMLElement>): void {
    //#region User
    $gridBinders.filter('[name="IndexUser"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "User",
            bindAdditionalGridButtons: function (this: GridBinder) {
                this.$parent.findInGrid('button[name="btnRemoveUserRole"]').off('click').on('click', (event: any) => {
                    const $btn = $(event.currentTarget);
                    const roleId = $btn.data('roleid');
                    if (!roleId) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        roleId: roleId,
                        userId: $btn.val(),
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}User/RemoveUserRole`,
                        data: data,
                        success: (data: AjaxSaveDetailsResult) => {
                            this.loadGridData(data);
                        },
                        error: (_xhr, _status, error) => {
                            console.log(error);
                        }
                    });
                });
            }
        });
        gridBinder.bindSearchBar();
    });
    //#endregion User

    //#region Role
    $gridBinders.filter('[name="IndexRole"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new (GridBinder)({
            $parent: $el,
            controller: "Role",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('button[name="btnRemovePermissionRole"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const permissionId = $btn.data('permissionid');
                    if (!permissionId) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        permissionId: permissionId,
                        roleId: $btn.val(),
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/RemovePermissionRole`,
                        data: data,
                        success: (data: any): void => {
                            this.loadGridData(data);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });
            }
        });
        gridBinder.bindSearchBar();
    });
    //#endregion Role

    //#region Permission
    $gridBinders.filter('[name="IndexPermission"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "Permission",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('button[name="btnRemoveRolePermission"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const roleId = $btn.data('roleid');

                    if (!roleId) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        roleId: roleId,
                        permissionId: $btn.val(),
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/RemoveRolePermission`,
                        data: data,
                        success: (data: any): void => {
                            this.loadGridData(data);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion Permission

    //#region RolePermissionAssigned
    $gridBinders.filter('[name="IndexRolePermissionAssigned"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "RolePermission",
            name: "IndexRolePermissionAssigned",
            searchUrl: "SearchRolePermission",
            csvUrl: "DownloadCsvRolePermission",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('button[name="Delete"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const roleId = $('#RolePermissionRolesList').val();

                    if (!roleId) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        roleId: roleId,
                        permissionId: $btn.val(),
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/DeleteRolePermission`,
                        data: data,
                        success: (data: any): void => {
                            if (data.error) {
                                $('div[name="messagePlaceHolder"]').html(data.content);
                            } else {
                                this.loadGridData(data);

                                //update otherGrid
                                if (GridBinder.instances.length > 1) {
                                    const otherGrid = GridBinder.instances.find(instance => instance.name == "IndexRolePermissionNotAssigned");
                                    if (otherGrid) {
                                        otherGrid.btnSearch.click();
                                    }
                                }
                            }
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion RolePermissionAssigned

    //#region RolePermissionNotAssigned
    $gridBinders.filter('[name="IndexRolePermissionNotAssigned"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "RolePermission",
            name: "IndexRolePermissionNotAssigned",
            searchUrl: "SearchRolePermission",
            csvUrl: "DownloadCsvRolePermission",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('button[name="Add"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const roleId = $('#RolePermissionRolesList').val();

                    if (!roleId) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        roleId: roleId,
                        permissionId: $btn.val(),
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/AddRolePermission`,
                        data: data,
                        success: (data: any): void => {
                            if (data.error) {
                                $('div[name="messagePlaceHolder"]').html(data.content);
                            } else {
                                this.loadGridData(data);

                                //update otherGrid
                                if (GridBinder.instances.length > 1) {
                                    const otherGrid = GridBinder.instances.find(instance => instance.name == "IndexRolePermissionAssigned");
                                    if (otherGrid) {
                                        otherGrid.btnSearch.click();
                                    }
                                }
                            }
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion RolePermissionNotAssigned

    //#region ApplicationLog
    $gridBinders.filter('[name="IndexApplicationLog"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "ApplicationLog",
            filterKeys: [
                FilterConstants.LOG_BY_LEVEL,
                FilterConstants.LOG_BY_SOURCECONTEXT,
                FilterConstants.LOG_BY_STATUSCODE,
                FilterConstants.LOG_BY_SERVER
            ],
            postFilterChange: function (this: GridBinder, event?: any): void {
                if (!event) {
                    return;
                }

                const $select = $(event.currentTarget);
                const selectedOption = $select.find(':selected');

                // Check if the selected option is the first one
                if (selectedOption.index() === 0) {
                    $select.css('color', '');
                } else {
                    const selectedColor = selectedOption.css('color');
                    $select.css('color', selectedColor);
                }
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion ApplicationLog

    //#region WebsiteContent
    $gridBinders.filter('[name="IndexWebsiteContent"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "WebsiteContent",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('td[colspan="100%"] .editControl').summernote({
                    height: 300,
                    minHeight: null,
                    maxHeight: null,
                    focus: true,
                    toolbar: [],
                    disableDragAndDrop: true,
                    disableResizeEditor: true,
                    disableResizeImage: true,
                    dialogsInBody: true,
                    callbacks: {
                        onInit: (): void => {
                            this.$parent.findInGrid('.note-editable').prop('contenteditable', false);
                        }
                    }
                } as any);
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion WebsiteContent

    //#region JobRegistry
    $gridBinders.filter('[name="IndexJobRegistry"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "JobRegistry",
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('button[name="btnRegisterJob"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const jobName = $btn.val();

                    if (!jobName) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        jobName: jobName,
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/AddOrUpdate`,
                        data: data,
                        success: (data: any): void => {
                            this.loadGridData(data);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });

                this.$parent.findInGrid('button[name="btnRemoveJob"]').off('click').on('click', (event: any): void => {
                    const $btn = $(event.currentTarget);
                    const jobName = $btn.val();

                    if (!jobName) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        jobName: jobName,
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/RemoveIfExists`,
                        data: data,
                        success: (data: any): void => {
                            this.loadGridData(data);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            console.log(error);
                        }
                    });
                });

                this.$parent.findInGrid('input.job-checkbox').off('change').on('change', (event: any): void => {
                    const $input = $(event.currentTarget);
                    const className = $input.data('classname');
                    const isChecked = $input.is(':checked');

                    if (!className) {
                        return;
                    }

                    const data = {
                        model: this.getSearchGridModel(),
                        className: className,
                        isEnabled: isChecked,
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/ToggleJobEnabled`,
                        data: data,
                        success: (data: any): void => {
                            this.loadGridData(data);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            $input.prop("checked", !isChecked); //Revert Switch Back if it fails
                            console.log(error);
                        }
                    });
                });
            }
        });

        gridBinder.bindSearchBar();
    });
    //#endregion JobRegistry

    //#region AllSqlQuery
    $gridBinders.filter('[name="IndexAllSqlQuery"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "AllSqlQuery",
        });

        gridBinder.bindSearchBar();
    });
    //#endregion AllSqlQuery

    //#region Feature
    $gridBinders.filter('[name="IndexFeature"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "Feature",
            filterKeys: [
                FilterConstants.FEATURE_BY_ENABLED,
                FilterConstants.FEATURE_BY_GROUP
            ],
            bindAdditionalGridButtons: function (this: GridBinder): void {
                this.$parent.findInGrid('input[name="featureToggleSwitch"]').off('change').on('change', (event: any): void => {
                    const $switch = $(event.currentTarget);
                    const featureId = $switch.data("feature-id");
                    const isChecked = $switch.is(":checked");
                    const gridModel = this.getSearchGridModel(this.page.val());

                    if (!featureId) {
                        return;
                    }

                    const data = {
                        featureId: featureId,
                        isChecked: isChecked,
                        gridModel: gridModel,
                    };

                    $.ajax({
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/FeatureToggle`,
                        data: data,
                        success: (response: AjaxSaveDetailsResult): void => {
                            this.loadGridData(response);
                        },
                        error: (xhr: any, status: any, error: any): void => {
                            $switch.prop("checked", !isChecked); //Revert Switch Back if it fails
                            console.log(error);
                        }
                    });
                });
            },
        });

        gridBinder.bindSearchBar();
    });
    //#endregion Feature
    //#region ProtectiveHealthCodesLicensee
    $gridBinders.filter('[name="IndexProtectiveHealthCodesLicensee"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "ProtectiveHealthCodesLicensee",
        });
        gridBinder.bindSearchBar();
    });
    //#endregion ProtectiveHealthCodesLicensee

    //#region ProtectiveHealthCodesLicenseesNearYou

    $gridBinders.filter('[name="IndexProtectiveHealthCodesLicenseesNearYou"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new GridBinder({
            $parent: $el,
            controller: "ProtectiveHealthCodesLicenseesNearYou",
            filterKeys: [
                FilterConstants.LICENSEE_BY_ZIP_CODE,
                FilterConstants.LICENSEE_BY_MIN_DISTANCE_TO_ZIP,
                FilterConstants.LICENSEE_BY_MAX_DISTANCE_TO_ZIP,
                FilterConstants.LICENSEE_BY_LICENSE_TYPE,
            ],
        });

        gridBinder.bindSearchBar();
    });
    //#endregion ProtectiveHealthCodesLicenseesNearYou
}

//#region Modal Select Grid Binders
function RegisterModalSelectGridBinders($gridBinders: JQuery<HTMLElement>): void {
    //#region UserSelect
    $gridBinders.filter('[name="modalUserSelect"]').each(function (this: HTMLElement) {
        const $el = $(this);
        const gridBinder = new (class extends ModalSelectGridBinder {
            constructor() {
                super(
                    $el,
                    "User",
                    "UserID",
                    "Select User"
                );
            }

            loadModalSelect(element: any, data: any): void {
                this.modalSelectHiddenField.val(data.Id);
                this.btnOpenModalSelect.text(data.UserName);
            }
        })();

        gridBinder.bindSearchBar();
    });
    //#endregion UserSelect
}
//#endregion Modal Select Grid Binders

//#region Modal Filter Grid Binders
function RegisterModalFilterGridBinders(gridBinder: GridBinder): void {
    gridBinder.filterKeys.forEach((filterKey: string) => {
        const $modalFilter = gridBinder.$parent.findInGrid(`.modalFilter[data-filter-key="${filterKey}"]`);

        if ($modalFilter.length > 0) {
            const modalFilterGridBinder = new (class extends ModalFilterGridBinder { constructor() { super($modalFilter, gridBinder, filterKey); } })();

            gridBinder.modalFilterGridBinders[filterKey] = modalFilterGridBinder;

            modalFilterGridBinder.bindSearchBar();
        }
    });
}
//#endregion Modal Filter Grid Binders
//#endregion Register Grid Binders